import { Box } from "@mui/material";
import Layout from "../../../layouts";
import { EconomicIndicatorProvider } from "../../../contexts/EconomicIndicatorContext";
import { TableEconomicIndicator } from "./TableEconomicIndicator";

export const EconomicIndicator = () => {
  return (
    <EconomicIndicatorProvider>
      <Layout>
        <Box display={"flex"} flexDirection={"column"} height={"100%"}>
          <Box height={"8px"}></Box>
          <Box
            flex={1}
            p={"40px 40px"}
            gap={"40px"}
            display={"flex"}
            flexDirection="column"
            alignItems={"start"}
            bgcolor={"var(--white)"}
          >
            <Box width={"100%"} height={"100%"} display={"flex"} flex={1}>
              <TableEconomicIndicator />
            </Box>
          </Box>
        </Box>
      </Layout>
    </EconomicIndicatorProvider>
  );
};
